import { AlignmentType, Paragraph, TextRun } from "docx";

export const TOCHeadings = new Paragraph({
    alignment: AlignmentType.CENTER,
    spacing: { before: 100, after: 100 },

    children: [
        new TextRun({
            text: "Contents",
            size: 36,
            color: "000000",
            font: "Calibri",
            bold: true,
            italics: false
        })
    ],
})